import { space } from '../mixins/space';
import { css } from '../style-system';
export { space } from '../mixins/space';
/**
 * @param {number} value
 */

export function margin(value) {
  return css({
    margin: space(value)
  });
}

margin.x = function (
/** @type {number} */
v) {
  return css({
    marginLeft: space(v),
    marginRight: space(v)
  });
};

margin.y = function (
/** @type {number} */
v) {
  return css({
    marginBottom: space(v),
    marginTop: space(v)
  });
};

margin.top = function (
/** @type {number} */
v) {
  return css({
    marginTop: space(v)
  });
};

margin.bottom = function (
/** @type {number} */
v) {
  return css({
    marginBottom: space(v)
  });
};

margin.left = function (
/** @type {number} */
v) {
  return css({
    marginLeft: space(v)
  });
};

margin.right = function (
/** @type {number} */
v) {
  return css({
    marginRight: space(v)
  });
};
/**
 * @param {number} value
 */


export function padding(value) {
  return css({
    padding: space(value)
  });
}

padding.x = function (
/** @type {number} */
v) {
  return css({
    paddingLeft: space(v),
    paddingRight: space(v)
  });
};

padding.y = function (
/** @type {number} */
v) {
  return css({
    paddingBottom: space(v),
    paddingTop: space(v)
  });
};

padding.top = function (
/** @type {number} */
v) {
  return css({
    paddingTop: space(v)
  });
};

padding.bottom = function (
/** @type {number} */
v) {
  return css({
    paddingBottom: space(v)
  });
};

padding.left = function (
/** @type {number} */
v) {
  return css({
    paddingLeft: space(v)
  });
};

padding.right = function (
/** @type {number} */
v) {
  return css({
    paddingRight: space(v)
  });
};